import type { ComponentSpec, WidgetResponseSpec } from "../Processing/types";
import type { GridWidgetType } from "../types";
import { mockChartSpec, mockChartResponse, mockResponseFromSpec } from "./chartMocks";
import { mockTableSpec, mockTableResponse, mockTableResponseFromSpec } from "./tableMocks";

export function getMockSpec(type: GridWidgetType): ComponentSpec {
  switch (type) {
    case "chart":
      return mockChartSpec();
    case "table":
      return mockTableSpec();
    case "title":
      return { type: "title", display: { title: "Weekly Report" } };
    case "logo":
      return { type: "logo", display: { teamName: "Sports Club", initials: "SC" } };
    default:
      return { type: "title", display: { title: "Widget" } };
  }
}

export function getMockResponse(type: GridWidgetType, widgetId: string): WidgetResponseSpec | null {
  switch (type) {
    case "chart":
      return mockChartResponse(widgetId);
    case "table":
      return mockTableResponse(widgetId);
    default:
      return null;
  }
}

/**
 * Generate a mock response whose query_ids are aligned with the given spec's
 * series definitions. Use this for widgets created through the configurator
 * where queryIds are dynamic UUIDs that won't match hardcoded mocks.
 */
export function getMockResponseForSpec(
  spec: ComponentSpec,
  widgetId: string,
): WidgetResponseSpec | null {
  switch (spec.type) {
    case "chart":
      return mockResponseFromSpec(spec, widgetId);
    case "table":
      return mockTableResponseFromSpec(spec, widgetId);
    default:
      return null;
  }
}
